import { render, staticRenderFns } from "./EmployeeMovementMedia.vue?vue&type=template&id=4891fafd&"
import script from "./EmployeeMovementMedia.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports